import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBelize = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_538)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 7.88152 21.9249 4.24809 18.7635 2.08697L12 1.5652L5.23655 2.08692C2.07516 4.24809 0 7.88156 0 12C0 16.1186 2.07516 19.7519 5.23655 21.913L12 22.4348L18.7635 21.9131C21.9249 19.7519 24 16.1186 24 12Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7635 2.08697C16.8376 0.770437 14.509 0 12 0C9.49113 0 7.16243 0.770437 5.23657 2.08697H18.7635Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.23657 21.913C7.16238 23.2296 9.49113 24 12 24C14.509 24 16.8376 23.2296 18.7635 21.913H5.23657Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 17.7391C15.1696 17.7391 17.7391 15.1696 17.7391 12C17.7391 8.83036 15.1696 6.26086 12 6.26086C8.83037 6.26086 6.26086 8.83036 6.26086 12C6.26086 15.1696 8.83037 17.7391 12 17.7391Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 16.6957C14.5933 16.6957 16.6956 14.5933 16.6956 12C16.6956 9.40666 14.5933 7.30434 12 7.30434C9.40664 7.30434 7.30432 9.40666 7.30432 12C7.30432 14.5933 9.40664 16.6957 12 16.6957Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 15.1305C13.7289 15.1305 15.1304 13.7289 15.1304 12C15.1304 10.2711 13.7289 8.86955 12 8.86955C10.2711 8.86955 8.86951 10.2711 8.86951 12C8.86951 13.7289 10.2711 15.1305 12 15.1305Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 11.2174L10.3043 12V13.3043L12 14.3478L13.6956 13.3043V12L12 11.2174Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.3043 10.4348H13.6956V12H10.3043V10.4348Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_538",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBelize;
